


















import Vue from 'vue';
import Component from 'vue-class-component';

import { mapActions } from 'vuex';

import Subheader from '@/components/maternite/Subheader.vue';
import PriseEnCharge from '@/components/maternite/PriseEnCharge.vue';
import Conges from '@/components/maternite/Conges.vue';
import ToDoList from '@/components/maternite/ToDoList.vue';
import Articles from '@/components/maternite/Articles.vue';
import PromoEspaceSante from '@/components/PromoEspaceSante.vue';

import dateGrossesseService from '@/services/dateGrossesseService.ts';

const Props = Vue.extend({
	props: {
		//date presumee grossesse
		dpg: {
			type: String,
			default: ''
		},
		//mois selectionné
		moisSel: {
			type: String,
			default: ''
		}
	}
});

/** Home page */
@Component({
	components: {
		Subheader,
		PriseEnCharge,
		Conges,
		ToDoList,
		Articles,
		PromoEspaceSante
	}
})
export default class AccueilMaternite extends Props {

	dateGrossesseService = dateGrossesseService;

	moisEnCours = this.dateGrossesseService.moisAffichage(this.dpg);

	get moisGrossesse():Number {
		if (this.moisSel != '') {
			return Number.parseInt(this.moisSel);
		} else {
			return Number.parseInt(this.moisEnCours.toString());
		}
	}

}
